import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import { WORKSPACE_VERSION } from '@/api/workspace';
import { validateWorkspace } from '@/api/workspace/endpoints/validateWorkspace.ts';
import type { Workspace } from '@/api/workspace/model.ts';
import type { WorkspaceForex } from '@/domain/WorkspaceForex/WorkspaceForex.ts';

export const getWorkspace = (builder: WebapiEndpointBuilder) =>
  builder.query<Workspace | undefined, void>({
    query: () => ({
      url: `/userdata/workspaceForex/${WORKSPACE_VERSION}`,
      method: 'GET',
    }),
    transformResponse,
  });

function transformResponse(workspace: WorkspaceForex | null | undefined): WorkspaceForex | undefined {
  return validateWorkspace(workspace) ?? undefined;
}
